module.exports = __webpack_public_path__ + "img/1440.c000ac8f.svg";